import { MdTrendingDown, MdTrendingFlat, MdTrendingUp } from "react-icons/md";

const TONES = {
  good: "bg-success-subtle text-success-fg",
  bad: "bg-danger-subtle text-danger-fg",
  flat: "bg-surface-subtle text-fg-muted",
};

/**
 * Change pill: up = success, down = danger (swapped with `invert`), 0 = neutral "No change".
 * Renders nothing when `value` is null/undefined/NaN.
 *
 * @param {object} props
 * @param {number} props.value Signed change, e.g. 12 or -3.5.
 * @param {boolean} [props.invert=false] For metrics where a decrease is good (e.g. "Needs Care").
 * @param {string} [props.suffix="%"] Unit appended to the absolute value.
 * @param {string} [props.id] DOM id (lets a parent reference it with aria-labelledby).
 * @param {string} [props.className]
 */
const TrendIndicator = ({ value, invert = false, suffix = "%", id, className = "" }) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return null;

  const numeric = Number(value);
  const direction = numeric > 0 ? "up" : numeric < 0 ? "down" : "flat";
  const tone =
    direction === "flat" ? "flat" : (direction === "up") !== invert ? "good" : "bad";
  const Icon =
    direction === "up" ? MdTrendingUp : direction === "down" ? MdTrendingDown : MdTrendingFlat;
  const amount = `${Math.abs(numeric).toLocaleString()}${suffix}`;

  return (
    <span
      id={id}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ${TONES[tone]} ${className}`.trim()}
    >
      <Icon aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />
      {direction === "flat" ? (
        "No change"
      ) : (
        <>
          <span className="sr-only">{direction === "up" ? "Up" : "Down"} </span>
          {amount}
        </>
      )}
    </span>
  );
};

export default TrendIndicator;
